import React from 'react';
import styled from 'styled-components';
import { withProductAccordion, IHOCReturnProps } from '@catalogo/service-americanas-product/src/hocs/product-accordion';
import Title from './components/title';
import ExpandButton from './components/expand-button';
import { TAnchorRef } from './types';
import { getRadiusStyleBoxValue } from './helpers';

const Container = styled.div<{ margin?: string }>`
  margin: ${({ margin }) => (margin ? margin : '20px 8px')};
  box-shadow: 0px 3px 10px -5px rgba(0, 0, 0, 0.25);
  position: relative;
  background: #fff;
  border-radius: ${getRadiusStyleBoxValue()};

  @media screen and (min-width: 1024px) {
    margin: ${({ margin }) => (margin ? margin : '20px 0 0 0')};
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
  }
`;

const ContentWrapper = styled.div`
  background: #fff;
  overflow: hidden;
  transition: max-height 0.5s 0s ease-in-out;
  border-radius: ${getRadiusStyleBoxValue(true)};
`;

const Content = styled.div<{ paddingContentAxisX?: number }>`
  padding: ${({ paddingContentAxisX }) => `16px ${paddingContentAxisX}px`};

  @media screen and (min-width: 1024px) {
    padding: 24px 16px;
  }
`;

export const AccordionBox: React.FC<IHOCReturnProps> = ({
  title,
  htmlElTitle,
  children,
  paddingContentAxisX,
  paddingTitleAxisX,
  forwardedRef,
  maxHeightCurrent,
  showExpandButton,
  toggleVisible,
  expandContent,
  isVisible,
  id,
  margin,
}) => (
  <Container margin={margin} id={id}>
    <Title
      toggleVisible={toggleVisible}
      title={title}
      isVisible={isVisible as boolean}
      htmlEl={htmlElTitle}
      paddingTitleAxisX={paddingTitleAxisX}
    />
    <ContentWrapper ref={forwardedRef as React.ForwardedRef<HTMLDivElement>} style={{ maxHeight: maxHeightCurrent }}>
      <Content paddingContentAxisX={paddingContentAxisX}>{children}</Content>
    </ContentWrapper>
    <ExpandButton showExpandButton={showExpandButton} expandContent={expandContent as () => void} />
  </Container>
);

AccordionBox.defaultProps = {
  paddingContentAxisX: 16,
  paddingTitleAxisX: 24,
  htmlElTitle: 'h3',
  anchorRef: '' as TAnchorRef,
};

export default withProductAccordion(AccordionBox);
